import React from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import { FormSecondHeading, FormThirdHeading } from '../styles/LayoutStyles';

const BATTERY_KEYS = ['firstBatteryCost', 'secondBatteryCost'];

const AddonsSection = ({ values, handleChange, addons, touched = {}, errors = {} }) => {
    const batteryAddons = (addons || []).filter(a => BATTERY_KEYS.includes(a.key));
    const otherAddons = (addons || []).filter(a => !BATTERY_KEYS.includes(a.key));

    const batteryOptions = [{ label: 'None', value: 'none' }];
    if (batteryAddons.some(a => a.key === 'firstBatteryCost')) {
        batteryOptions.push({ label: '5 kWh', value: '5kw' });
    }
    if (batteryAddons.some(a => a.key === 'secondBatteryCost')) {
        batteryOptions.push({ label: '10 kWh', value: '10kw' });
    }

    return (
        <Row className='body-row'>
            <Col xs={12} sm={12} md={12} lg={12}>
                <Row>
                    <div className='icon-row'>
                        <FormSecondHeading>Final options</FormSecondHeading>
                    </div>
                </Row>
                <FormThirdHeading>Choose the inverter, battery storage, and any optional extras for your system.</FormThirdHeading>
            </Col>
            <Col xs={12} sm={12} md={12} lg={12}>
                <div className='addons-grid'>
                    <Form.Group as={Row} className="align-items-center" style={{ marginBottom: '10px' }}>
                        <Form.Label column xs={6}>Inverter type</Form.Label>
                        <Col xs={6}>
                            <Form.Select
                                name='inverterOption'
                                value={values.battery && values.battery !== 'none' ? 'hybrid' : values.inverterOption}
                                onChange={handleChange}
                                disabled={Boolean(values.battery && values.battery !== 'none')}
                                isValid={touched.inverterOption && !errors.inverterOption}
                                isInvalid={!!errors.inverterOption}
                            >
                                <option value="" disabled>Choose</option>
                                <option value='standard'>Standard - for systems without batteries</option>
                                <option value='hybrid'>Hybrid - for systems with battery storage</option>
                            </Form.Select>
                            <Form.Control.Feedback type='invalid'>
                                {errors.inverterOption}
                            </Form.Control.Feedback>
                        </Col>
                    </Form.Group>
                    {batteryOptions.length > 1 && (
                        <Form.Group as={Row} className="align-items-center" style={{ marginBottom: '10px' }}>
                            <Form.Label column xs={6}>Battery storage</Form.Label>
                            <Col xs={6}>
                                <Form.Select
                                    name="battery"
                                    value={values.battery || 'none'}
                                    onChange={handleChange}
                                >
                                    {batteryOptions.map(opt => (
                                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                                    ))}
                                </Form.Select>
                            </Col>
                        </Form.Group>
                    )}
                    {otherAddons.map(({ key, name }) => (
                        <Form.Group key={key} style={{ marginBottom: '10px' }}>
                            <Form.Check
                                type='checkbox'
                                name={key}
                                id={`addon-${key}`}
                                label={name}
                                value="true"
                                checked={values[key] || false}
                                onChange={handleChange}
                            />
                        </Form.Group>
                    ))}
                </div>
            </Col>
        </Row>
    );
};

export default AddonsSection;
